import { createFileRoute, useParams } from "@tanstack/react-router";
import { requireFeature } from "@/lib/feature-gate";
import { ProjectDetailPage } from "@/components/project/ProjectDetailPage";

export const Route = createFileRoute("/admin/_layout/projects_/$id")({
  beforeLoad: () => requireFeature("projects"),
  component: AdminProjectDetail,
});

function AdminProjectDetail() {
  const { id } = useParams({ from: "/admin/_layout/projects_/$id" });
  return (
    <ProjectDetailPage
      projectId={Number(id)}
      isAdmin={true}
      backTo="/admin/projects"
      
    />
  );
}
